var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      ref: "drawerExample",
      attrs: {
        wrapperClosable: false,
        modal: false,
        title: _vm.$t("pc_biz_ote_lbl_templatesample" /** 标准格式示例 */),
        visible: _vm.states.isShowStandardFormatExample,
        size: "640px",
        direction: _vm.direction,
        "before-close": _vm.close,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.states, "isShowStandardFormatExample", $event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-ai-create-ques-temp yxtbiz-intelligent-questioning",
        },
        [
          _c("div", { staticClass: "yxtbiz-ai-create-ques-temp__desc" }, [
            _c(
              "div",
              { staticClass: "standard-size-12 color-gray-10 yxt-weight-5" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("pc_biz_ote_lbl_desctemplate" /** 规范说明 */)
                    ) +
                    "\n      "
                ),
              ]
            ),
            _c(
              "ul",
              {
                staticClass: "yxtbiz-ai-create-ques-temp__desc-list",
                class: !_vm.isShowMore
                  ? "yxtbiz-ai-create-ques-temp__desc-list--simple"
                  : "",
              },
              _vm._l(_vm.quickTips, function (tip) {
                return _c("li", { key: tip }, [
                  _vm._v("\n          " + _vm._s(tip) + "\n        "),
                ])
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "pl20 mt4" },
              [
                _c(
                  "yxt-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        _vm.isShowMore = !_vm.isShowMore
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.isShowMore
                            ? _vm.$t("pc_biz_ote_btn_putaway")
                            : _vm.$t("pc_biz_ote_btn_expand")
                        )
                      ),
                    ]),
                    _c("span", {
                      staticClass: "ml3",
                      class: _vm.isShowMore
                        ? "yxt-icon-arrow-up"
                        : "yxt-icon-arrow-down",
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "standard-size-12 color-gray-10 yxt-weight-5 mt24" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("pc_biz_ote_lbl_questemplate" /** 题型示例 */)
                  ) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-ai-create-ques-temp__example mt8" },
            [
              _c(
                "yxt-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.quesType,
                    callback: function ($$v) {
                      _vm.quesType = $$v
                    },
                    expression: "quesType",
                  },
                },
                [
                  _c("yxt-tab-pane", {
                    key: "-1",
                    attrs: {
                      label: _vm.$t(
                        "pc_biz_ote_lbl_allquestype" /** 全部题型 */
                      ),
                      name: "-1",
                    },
                  }),
                  _vm._l(
                    _vm.QUES_TYPE_NAMES.filter(function (e, i) {
                      return i < 5
                    }),
                    function (item, index) {
                      return _c("yxt-tab-pane", {
                        key: index,
                        attrs: { label: _vm.$t(item), name: index + "" },
                      })
                    }
                  ),
                ],
                2
              ),
              _c("div", { staticClass: "mt8 mh24 color-gray-9 mb24" }, [
                ["-1", "0"].includes(_vm.quesType)
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques-temp__ques" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            [" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_questype0")) +
                              "][" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_difficult")) +
                              "]" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques01")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            A. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques02")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            B. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques03")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            C. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques04")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            D. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques05")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                              ": B\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) +
                              ":\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_quickquesanalyze2")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm.quesType === "-1" ? _c("br") : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                ["-1", "1"].includes(_vm.quesType)
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques-temp__ques" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            [" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_questype1")) +
                              "][" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_medium")) +
                              "]" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques06")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            A. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques02")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            B. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques03")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            C. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques04")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            D. " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques05")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                              ": A C D\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) +
                              ":\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_quickquesanalyze1")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm.quesType === "-1" ? _c("br") : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                ["-1", "2"].includes(_vm.quesType)
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques-temp__ques" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            [" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_questype2")) +
                              "][" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_easy")) +
                              "]" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques08-1")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                              ":\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_wrong")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) +
                              ":\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_quickquesanalyze2")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm.quesType === "-1" ? _c("br") : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                ["-1", "3"].includes(_vm.quesType)
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques-temp__ques" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            [" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_questype3")) +
                              "][" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_medium")) +
                              "]" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques07")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                              ":\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques02")) +
                              "；" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques04")) +
                              "；" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques05")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) +
                              ":\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_quickquesanalyze1")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm.quesType === "-1" ? _c("br") : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                ["-1", "4"].includes(_vm.quesType)
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques-temp__ques" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            [" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_questype4")) +
                              "][" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_difficult")) +
                              "]" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques09")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                              ":\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques02")) +
                              "；" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques04")) +
                              "；" +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quickques05")) +
                              "\n          "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) +
                              ":\n            " +
                              _vm._s(
                                _vm.$t("pc_biz_ote_lbl_quickquesanalyze1")
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }